import React, { useEffect, useRef, useState } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Loader from '../LoadingSpinner/LoadingSpinner';

const SearchBar = ({
        placeholder = 'Search',
        onSearch,
        isLoading = false,
        className,
        debounceDelay = 500,
}) => {
        // const [inputValue, setInputValue] = useState('');

        // useEffect(() => {
        //         const handler = setTimeout(() => {
        //                 if (onSearch) onSearch(inputValue);
        //         }, debounceDelay);

        //         return () => {
        //                 clearTimeout(handler);
        //         };
        // }, [inputValue, onSearch, debounceDelay]);

        const [inputValue, setInputValue] = useState('');
        const isFirstRender = useRef(true);
        const onSearchRef = useRef(onSearch);
        onSearchRef.current = onSearch;

        useEffect(() => {
                if (isFirstRender.current) {
                        isFirstRender.current = false;
                        return;
                }

                const handler = setTimeout(() => {
                        if (onSearchRef.current) onSearchRef.current(inputValue);
                }, debounceDelay);

                return () => {
                        clearTimeout(handler);
                };
        }, [inputValue, debounceDelay]);

        return (
                <div className={`w-[24%] h-[40px] ${className}`}>
                        <Input
                                size="large"
                                placeholder={placeholder}
                                prefix={
                                        isLoading ? (
                                                <Loader className="!w-[20px] !h-[20px] border-2" />
                                        ) : (
                                                <SearchOutlined className="text-gray-400" />
                                        )
                                }
                                className="rounded-lg shadow-sm font-inter font-normal text-4 leading-6 h-full"
                                onChange={(e) => setInputValue(e.target.value)}
                                disabled={isLoading}
                        />
                </div>
        );
};

export default SearchBar;
